module.exports = __webpack_public_path__ + "static/media/test6.a0d6efeb.jpeg";